import { useEffect, type ReactNode } from "react";

import { useQueryClient } from "@tanstack/react-query";

import { onSessionReplaced, startAuthSession } from "@/api";

/**
 * Запускает сессию вкладки: один `isauthorized` при загрузке приложения (single-flight в `authSession`,
 * поэтому двойной эффект StrictMode не даёт второго запроса). Только в браузере — из эффекта.
 * Состояние читается через `useAuth()`; кэш при выходе чистит подписка `onSessionEnded` в `Providers`.
 */
export function AuthProvider({ children }: { children: ReactNode }) {
    const queryClient = useQueryClient();

    useEffect(() => {
        void startAuthSession();
    }, []);

    // Вход другой учётной записью поверх открытой сессии (например, после сброса пароля).
    useEffect(() => onSessionReplaced(() => queryClient.clear()), [queryClient]);

    return children;
}
